// extracted by mini-css-extract-plugin
export default {"title":"MultipleChoiceQuestion_title__UwSwb","optional":"MultipleChoiceQuestion_optional__Igjxe","checkboxes":"MultipleChoiceQuestion_checkboxes__2nXOG"};